import { connect } from "react-redux";
import ExamStatus from "../components/ExamStatus";
var mapStateToProps = function(state, ownProps) {
    return {
        visible: !!state.exam && state.exam.state === "running",
        exam: state.exam,
        allowNavigation: state.exam && state.nodes.find(function(n) {
            return n.id === state.exam.id;
        }) && state.nodes.find(function(n) {
            return n.id === state.exam.id;
        }).allow_navigation,
        questionCount: !!state.exam && state.examInteractions[state.exam.id] ? state.examInteractions[state.exam.id].length : 0
    };
};
export default connect(mapStateToProps, null)(ExamStatus);
